import { Subscription } from 'rxjs';
import { Component, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { AnalysisType } from 'src/app/navigation/services/navigation-services/parent-navigation-service';
import { LicenseService } from 'src/app/services/licensing-service';
import { MenuPositionX } from '@angular/material/menu';

export enum AnalysisMenuCaller {
  Homepage,
  Sidenav,
  Packaging,
  StartingPage
}

export class MenuItem {
  versionId?: number;
  date = '';
  time = '';
  analysisVersions!: { displayDate: string, underlyingDate: Date, analysisVersionsId: (string | undefined)[] }[];
  analysisType?: number;
}

export class PackagingValidationMapping {
  id = -1;
  isFullyValidatedAllValid = false;
  isFullyValidatedNotAllValid = false;
  isNotFullyValidated = false;
  isCurrent = false;
  isUntouched = false;
}

@Component({
  selector: 'app-analyses-menu-parent',
  templateUrl: './analyses-menu-parent.component.html',
  styleUrls: ['./analyses-menu-parent.component.scss']
})
export class AnalysesMenuParentComponent implements OnDestroy {

  @Input() versionId = -1;
  @Input() hasRecyclabilityResult = false;
  @Input() hasLifeCycleResult = false;
  @Input() creationTimestamp!: Date;
  @Input() isUserValidator = false;
  @Input() caller!: AnalysisMenuCaller;

  @Output() validationData = new EventEmitter();

  recyclabilityAnalysisMenu: { menuItems: MenuItem[], analysisType: number };
  lcaAnalysisMenu: { menuItems: MenuItem[], analysisType: number };
  lcaCradleToGateAnalysisMenu: { menuItems: MenuItem[], analysisType: number };
  expenseCalculationMenu: { menuItems: MenuItem[], analysisType: number };

  isAnalysisAllowed = true;
  menuDirectionX: MenuPositionX = 'before';

  protected recSubscription?: Subscription;
  protected lcaSubscription?: Subscription;
  protected expenseSubscription?: Subscription;
  protected lcaCradleToGateSubscription?: Subscription;
  protected permissionsSubscription?: Subscription;
  protected analysisPossibleSubscription?: Subscription;
  protected versionsSubscription?: Subscription;
  protected timestampSubscription?: Subscription;

  recMenuItemsLoaded?: Promise<boolean>;
  lcaMenuItemsLoaded?: Promise<boolean>;
  lcaCradleToGateMenuItemsLoaded?: Promise<boolean>;
  expenseMenuItemsLoaded?: Promise<boolean>;

  constructor(private licenseService: LicenseService) {
    this.recyclabilityAnalysisMenu = { menuItems: [], analysisType: AnalysisType.Recyclability };
    this.lcaAnalysisMenu = { menuItems: [], analysisType: AnalysisType.Lifecycle };
    this.lcaCradleToGateAnalysisMenu = { menuItems: [], analysisType: AnalysisType.CradleToGateLifecycle };
    this.expenseCalculationMenu = { menuItems: [], analysisType: AnalysisType.ExpenseCalculation}
  }

  protected getDateTimeString(date: string) {
    const dateDate = new Date(date);
    return `${dateDate.toLocaleDateString()}: ${dateDate.toLocaleTimeString()}`;
  }

  ngOnDestroy(): void {
    this.recSubscription?.unsubscribe();
    this.lcaSubscription?.unsubscribe();
    this.expenseSubscription?.unsubscribe();
    this.permissionsSubscription?.unsubscribe();
    this.analysisPossibleSubscription?.unsubscribe();
    this.versionsSubscription?.unsubscribe();
    this.timestampSubscription?.unsubscribe();
  }

  isLcaAllowed(): boolean {
    return this.licenseService.isCradleToGraveAllowed || this.licenseService.isCradleToGateAllowed;
  }

  isC2GateAllowed(): boolean {
    return this.licenseService.isCradleToGateAllowed;
  }

  isC2GraveAllowed(): boolean {
    return this.licenseService.isCradleToGraveAllowed;
  }

  isCCAllowed(): boolean {
    return this.licenseService.isCCAllowed;
  }
}
